module.exports = __webpack_public_path__ + "img/cattunnel10.895a0768.jpg";